<template>
  <div class="max-h-96 overflow-y-auto">
    <div
      v-if="searchFiltersStore.getUserSearchFilters.length > 0"
      class="flex flex-col space-y-[7.5px]"
    >
      <SavedFilterRow
        v-for="savedFilter in searchFiltersStore.getUserSearchFilters"
        :key="savedFilter.id"
        :saved-filter="savedFilter"
      />
    </div>

    <div v-else class="flex flex-col items-center justify-center h-full py-10">
      <img
        src="/images/no-saved-filters.png"
        :alt="$t('appliedFilters.noSavedFilters')"
      />
      <p
        class="mt-9 text-gray-500 text-sm font-semibold font-['Inter'] leading-tight"
      >
        {{ $t("appliedFilters.youCurrentlyDoNotHaveAnySavedFilters") }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import SavedFilterRow from "./SavedFilterRow.vue";
import { useSearchFiltersStore } from "@/store/searchFilter";

const searchFiltersStore = useSearchFiltersStore();
</script>
